const awsmobile = {
  "aws_user_pools_web_client_id": "7ch2s7i29rjgv4v3s2jcssc5c9", //This id is referenced at
};


export default awsmobile;
